import axios from 'axios';
import config from '../../config/configureSettings';
import { constructServiceURL } from '../../core/modules/common/tools/URLTools';

export const fetchDespatch = (despatchId) => axios.get(constructServiceURL({
  endpoint: 'fetchDespatch',
  stub: config.useStubbedEndpoints,
  params: { despatchId },
}));
